export function convertToCSV(objArray) {
  const array = typeof objArray === "string" ? JSON.parse(objArray) : objArray;
  if (!Array.isArray(array) || array.length === 0) {
    return "";
  }

  // Build header row
  const headers = Object.keys(array[0]);
  const escape = (val) => {
    let s = val == null ? "" : String(val);
    if (s.includes('"')) {
      s = s.replace(/"/g, '""');
    }
    return `"${s}"`;
  };

  let csv = headers.map(escape).join(",") + "\r\n";

  // Build each data row
  array.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

/**
 * Filter your sales transactions, build a CSV, and trigger download.
 *
 * @param {Object[]} objects              — full list of transactions
 * @param {string}  selectedYear
 * @param {string}  selectedMonthName
 * @param {string}  selectedStoreCode
 * @param {string}  [brandName="Angels Pizza"]
 * @param {string}  [fileNamePrefix="SalesDiscount"]
 */
export function exportSalesDiscountCSV({
  objects,
  selectedYear,
  selectedMonthName,
  selectedStoreCode,
  brandName = "Angels Pizza",
  fileNamePrefix = "SalesDiscount",
}) {
  // 1) Filter status C
  let filtered = objects.filter((obj) => obj.status === "C");

  // 2) Filter by year / month / store
  filtered = filtered.filter((sale) => {
    const date = new Date(sale.createdAt || sale.tran_date);
    const year = date.getFullYear();
    const month = date.toLocaleString("default", { month: "long" });
    const storeCode = sale.store_code;

    const yearOk = selectedYear ? year === parseInt(selectedYear, 10) : true;
    const monthOk = selectedMonthName ? month === selectedMonthName : true;
    const storeOk = selectedStoreCode ? storeCode === selectedStoreCode : true;

    return yearOk && monthOk && storeOk;
  });

  // 3) Map into plain objects matching CSV columns
  const dataRows = filtered.map((sale) => {
    const date = new Date(sale.tran_date || sale.createdAt);
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    const sales = Number(sale.total || 0);
    const discountAmount = sale.discount_amount || 0;
    const store = sale.store_code.split("_")[1] || sale.store_code;

    return {
      Brand: brandName,
      Store: store,
      Month: month,
      Year: year,
      Sales: sales,
      "Discount Amount": discountAmount,
    };
  });

  // 4) Convert to CSV string
  const csvString = convertToCSV(dataRows);
  if (!csvString) {
    console.error("exportSalesDiscountCSV: no data to download");
    return;
  }

  // 5) Trigger file download
  const blob = new Blob([csvString], {
    type: "text/csv;charset=utf-8;",
  });
  const link = document.createElement("a");
  const datePart = `${selectedYear || ""}_${selectedMonthName || ""}`;
  link.href = URL.createObjectURL(blob);
  link.download = `${fileNamePrefix}_${datePart}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
